export default __webpack_public_path__ + "static/media/pinTriangle.cc4cbc66.svg";